<ng-container *ngIf="(account$ | async) as account">

  <p-table 
    #eventTypesTable 
    [value]="account.data.eventTypes" 
    [globalFilterFields]="['name']"
    styleClass="mt-5 p-datatable-striped" 
    dataKey="_meta.id" 
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="eventTypesTable.filterGlobal($any($event).target.value, 'contains')" placeholder="Search keyword" />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-eventType>
      <tr [pSelectableRow]="eventType">
        <td class="eventtype-text">{{ eventType.name }}</td>
        <td class="eventType-actions">
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onEditEventType($event, eventType)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="!eventType.disabled" pButton pRipple type="button" icon="pi pi-trash" (click)="onDeleteEventType($event, eventType)" class="p-button-rounded p-button-danger p-button-text"></button>
          <button *ngIf="eventType.disabled" pButton pRipple type="button" icon="pi pi-refresh" (click)="onRestoreEventType($event, eventType)" class="p-button-rounded p-button-success p-button-text"></button>
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>